const cnWidgetHelperPlugin = {
  install (Vue, options) {
    Vue.prototype.imageCache = (url, action, MAX_WIDTH, MAX_HEIGHT) => {
      if (!url || !url.match(/https?:\/\//)) { return }
      if (action === 'favicon') {
        url = 'https://www.google.com/s2/favicons?domain=' + url.split('/')[2]
        action = 'cache'
      }
      url = encodeURIComponent(url)
      var protocol = 'https:'
      var imagecacheurl = '//imagecache.crowdynews.com/'
      var BASE_URL = protocol + imagecacheurl
      var imageURL = MAX_HEIGHT
        ? BASE_URL + action + '/' + MAX_WIDTH + '/' + MAX_HEIGHT + '/?url=' + url
        : BASE_URL + action + '/' + MAX_WIDTH + '/?url=' + url
      if (action === 'resize' || action === 'crop') { return imageURL }
      return BASE_URL + 'cache/?url=' + url
    }
    Vue.prototype.getFavicon = (url) => {
      return 'https://www.google.com/s2/favicons?sz=64&domain_url=' + url
    }
  }
}
module.exports = cnWidgetHelperPlugin
